import { useEffect, useState } from 'react'
import { useInView } from 'react-intersection-observer'

import { useRoomsQuery } from '../api/get-rooms'

type Props = {
  isMounted: boolean
}

export const useRooms = ({ isMounted }: Props) => {
  const { data, isLoading, isFetching, hasNextPage, fetchNextPage } =
    useRoomsQuery({
      enabled: isMounted,
    })

  const { rooms, isFirstPage } = data ?? {
    rooms: null,
    isFirstPage: null,
  }

  const { ref, inView } = useInView()

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (inView && hasNextPage) {
      void fetchNextPage()
    }
  }, [inView])

  useEffect(() => {
    // 첫 렌더링 시 마운트 되기 전부터 계속 로딩 상태가 보여지므로
    // 똑같이 500ms 기다리도록 하면 로딩이 조금 길어지는 것처럼 보임
    // 데이터 요청 완료 후 바로 초기화
    if (!isMounted) {
      setLoading(false)

      return
    }

    // 로딩 상태 때문에 깜빡이는 것처럼 보이지 않도록 로딩 지연
    // 500ms 뒤에 로딩 상태를 초기화
    if (isLoading && !loading) {
      setLoading(true)

      setTimeout(() => {
        setLoading(false)
      }, 300)
    }
  }, [isLoading, loading])

  return {
    rooms,
    ref,
    loading: isLoading || loading,
    isFetching,
    isFirstPage,
  }
}
